import * as React from "react";
import { BehaviorSubject, Subscription } from 'rxjs';
import { Action } from "./action";

interface Actions {
    updateState: (state: object) => void;
    executeAction: <TIn, TOut>(action: Action<TIn, TOut>, state?: object, data?: TIn) => void;
}

export type ActionsExecutorPropsType = Actions;

export function withActionsExecutor<TP, TS>(state: TS, WrappedComponent: React.ComponentClass<TP & ActionsExecutorPropsType> | React.SFC<TP & ActionsExecutorPropsType>): React.ComponentType<TP> {
    return class Component extends React.Component<TP, TS> {

        private state$: BehaviorSubject<TS>;
        private stateSubscr: Subscription;
        private initialState: TS;
        private actions: Actions;
        private executedActions: Array<Subscription>;

        constructor(props: TP) {
            super(props);

            this.state$ = new BehaviorSubject(state);
            this.initialState = state;
            this.actions = {
                executeAction: this.executeAction,
                updateState: this.updateState
            }
        };

        private addActionSubscription = (subsc: Subscription) => {
            this.executedActions.push(subsc);
        }

        private removeActionSubscription = (subsc: Subscription) => {
            subsc.unsubscribe();
            const index = this.executedActions.indexOf(subsc);
            if (index > -1) {
                this.executedActions.splice(index, 1);
            }
        }

        private executeAction = <TIn, TOut>(action: Action<TIn, TOut>, state?: object, data?: TIn) => {

            if (state !== undefined) {
                this.updateState(state);
            }

            const subsc = action.getExecute$()
                //.debounceTime(2000)
                .subscribe(
                    result => {
                        this.removeActionSubscription(subsc);
                        action.handleSuccess(result);
                    },
                    error => {
                        this.removeActionSubscription(subsc);
                        action.handleError(error);
                    });

            this.addActionSubscription(subsc);

            action.execute(data);
        }

        private updateState = (state: object) => this.state$.next(Object.assign(this.state, state));

        componentWillMount() {
            this.executedActions = new Array<Subscription>();
            this.stateSubscr = this.state$.subscribe((state) => this.setState(state));
            this.setState(this.state$.value);
        }

        componentWillUnmount() {

            if (this.stateSubscr !== undefined) {
                this.stateSubscr.unsubscribe();
                this.stateSubscr = undefined;
            }

            for (const a of this.executedActions) {
                a.unsubscribe();
            }
        }

        render() {
            return React.createElement(WrappedComponent, Object.assign({}, this.props, this.state, this.actions));
        }
    }
}